import { memo } from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../userAvatar';

const Reviewer = ({ reviewer }) => {
  return <UserAvatar user={reviewer} variant="subtitle2" small caption />;
};

Reviewer.propTypes = {
  reviewer: PropTypes.object.isRequired,
};

export default memo(Reviewer);
